import { postUpdateMiniCart, postDeleteMiniCartItem, getQuotesCount, postSaveQuote, getGetCartInfo } from '@_api/minicart';
import { getCurrentRegion } from '@helpers/functions';

const miniCart = {
  elem: document?.querySelector<HTMLElement>('.saig-o-mini-cart'),
  listItemMiniCart: document?.querySelector<HTMLElement>('.saig-o-header-menu__icons__item__cart'),
  currentQtyDiv: document?.querySelector<HTMLElement>('drpQuantity_1'),
  itemExistsContainer: document?.querySelector<HTMLDivElement>('.saig-o-mini-cart__item-exists'),
  itemNotExistsContainer: document?.querySelector<HTMLDivElement>('.saig-o-mini-cart__item-not-exists'),
  cartCounter: document?.querySelector<HTMLDivElement>('.saig-a-button.button-cart > .saig-a-button__counter'),
  updateCartInfoURL: '',
  deleteLineItemURL: '',
  getQuotesCountURL: '',
  getCartInfoURL: '',
  saveQuotesURL: '',
  quotesPageUrl: '',
  cartId: '',
  popUpIdDocumentLicenseRules: '',
  cartPageUrl: '',
  popUpIdMoreInfo: '',
  popUpIdQuoteItemQtyMaximum: '',
  lineItemId: '',
  init: function () {
    this.addEvent();
    this.getParsedAPIUrls();
    window.addEventListener('getCartInfo', (event: any) => {
      this.getCartInfo();
    });
  },
  getParsedAPIUrls: function () {
    const cartContainer = this.elem?.querySelector<HTMLDivElement>('.saig-o-mini-cart__inner-wrapper');
    const apiUrls = cartContainer?.dataset.attrGeneric || '';
    const parsedAPIUrls = apiUrls && JSON.parse(apiUrls?.replace(/&quot;/g, '"'));
    if (parsedAPIUrls) {
      this.updateCartInfoURL = parsedAPIUrls?.UpdateCartInfoURL;
      this.deleteLineItemURL = parsedAPIUrls?.DeleteMiniCartItemURL;
      this.popUpIdDocumentLicenseRules = parsedAPIUrls?.PopUpIdDocumentLicenseRules;
      this.popUpIdQuoteItemQtyMaximum = parsedAPIUrls?.popUpIdQuoteItemQtyMaximum;
      this.cartPageUrl = parsedAPIUrls?.CartPageUrl;
      this.getQuotesCountURL = parsedAPIUrls?.GetQuotesCountURL;
      this.saveQuotesURL = parsedAPIUrls?.SaveQuotesURL;
      this.quotesPageUrl = parsedAPIUrls?.QuotesPageUrl;
      this.cartId = parsedAPIUrls?.CartId;
      this.getCartInfoURL = parsedAPIUrls?.GetCartInfoURL;
    }
  },
  addEvent: function () {
    this.elem = document?.querySelector<HTMLElement>('.saig-o-mini-cart');
    let qtySelectOptions = document?.querySelectorAll<HTMLElement>('.saig-o-mini-cart__item-details-qty-select');
    let moreInfoLinks = document?.querySelectorAll<HTMLElement>('.saig-o-mini-cart__item-format-info-link');
    let licenseRules = document?.querySelector<HTMLButtonElement>('.saig-o-mini-cart__license-rules>a');
    let deleteButtons = document?.querySelectorAll<HTMLButtonElement>('.saig-a-button.delete-button');
    let iconBack = this.elem?.querySelector<HTMLButtonElement>('.icon-back');
    let iconClose = this.elem?.querySelector<HTMLButtonElement>('.icon-close');

    for (const select of qtySelectOptions) {
      select?.addEventListener('change', this.changeQuantityMiniCart.bind(this));
    }
    for (const link of moreInfoLinks) {
      link?.addEventListener('click', this.moreInfoClickHandler.bind(this));
    }
    licenseRules?.addEventListener('click', this.licenseRuleClickHandler.bind(this));
    iconBack?.addEventListener('click', this.closeButtonClickHandler.bind(this));
    iconClose?.addEventListener('click', this.closeButtonClickHandler.bind(this));
    for (const button of deleteButtons) {
      button?.addEventListener('click', this.deleteMiniCartItem.bind(this));
    }
  },
  closeButtonClickHandler: function (event: any) {
    event?.preventDefault();
    event?.stopPropagation();
    const cartDiv = document?.querySelector<HTMLDivElement>('.saig-o-header-menu__mini-cart');
    const  PriceSectionMobile =document?.querySelector<HTMLDivElement>('.saig-o-product-header__mobile-bottom-fixed');
    PriceSectionMobile?.classList.remove('hide') ;
    cartDiv?.classList.remove('show');
    document?.querySelector('body')?.classList.remove('modal-overlay-on');
  },

  deleteMiniCartItem: function (event: any) {
    const parentDiv = event.currentTarget?.closest('.saig-o-mini-cart__item');
    this.getDataAttributes(event);
    postDeleteMiniCartItem(this.lineItemId, this.deleteLineItemURL ?? '')
      .then((response) => {
        if (response != null) {
          this.postRemoveFromCartEventToGA(true, parentDiv, "0");
          this.getCartInfo();
        }
      })
      .catch((error) => {
        console.log('error calling API: ' + error);
      });
  },
  triggerGAEventOnQuantityChange: function (parentDiv: any, changedQuantity: string) {
    const dataAttr = parentDiv?.dataset.attrItem;
    const parsedDataAttr = dataAttr && JSON.parse(dataAttr?.replace(/&quot;/g, '"'));

    var quantity = parseInt(parsedDataAttr.quantity);

    if (parseInt(changedQuantity) > quantity) {
      this.postAddToCartEventToGA(parentDiv, changedQuantity)
    } else {
      this.postRemoveFromCartEventToGA(false, parentDiv, changedQuantity);
    }

  },
  postAddToCartEventToGA: function (parentDiv: any, changedQuantity: string) {
    try {
      const dataAttr = parentDiv?.dataset.attrItem;
      const parsedDataAttr = dataAttr && JSON.parse(dataAttr?.replace(/&quot;/g, '"'));

      var quantity = parseInt(parsedDataAttr.quantity);
      quantity = parseInt(changedQuantity) - quantity;

      const productObj = {
        event: "add_to_cart",
        region: getCurrentRegion(),
        currency: parsedDataAttr.currencyMnemonic,
        value: parseFloat(parsedDataAttr.singleBasePrice.replace(/[^.0-9]/g, "")) * quantity,
        items: [
          {
            item_id: parsedDataAttr.masterProductSKU,
            item_name: parsedDataAttr.productName,
            item_brand: parsedDataAttr.publisherName,
            item_variant: parsedDataAttr.format,
            price: parseFloat(parsedDataAttr.singleBasePrice.replace(/[^.0-9]/g, "")),
            quantity: quantity
          }
        ]
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(productObj);
    } catch {
      console.error('Error in add to cart event');
    }
  },
  postRemoveFromCartEventToGA: function (isDelete: boolean, parentDiv: any, changedQuantity: string) {
    try {
      const dataAttr = parentDiv?.dataset.attrItem;
      const parsedDataAttr = dataAttr && JSON.parse(dataAttr?.replace(/&quot;/g, '"'));

      var quantity = parseInt(parsedDataAttr.quantity);

      if (!isDelete) {
        quantity = quantity - parseInt(changedQuantity);
      }

      const productObj = {
        event: "remove_from_cart",
        region: getCurrentRegion(),
        currency: parsedDataAttr.currencyMnemonic,
        value: isDelete ? parseFloat(parsedDataAttr.totalPrice.replace(/[^.0-9]/g, "")) :
          parseFloat(parsedDataAttr.singleBasePrice.replace(/[^.0-9]/g, "")) * quantity,
        items: [
          {
            item_id: parsedDataAttr.masterProductSKU,
            item_name: parsedDataAttr.productName,
            item_brand: parsedDataAttr.publisherName,
            item_variant: parsedDataAttr.format,
            price: parseFloat(parsedDataAttr.singleBasePrice.replace(/[^.0-9]/g, "")),
            quantity: quantity
          }
        ]
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(productObj);
    } catch {
      console.error('Error in remove from cart event');
    }
  },
  getCartInfo: function () {
    getGetCartInfo(this.getCartInfoURL ?? '').then((response) => {
      if (response != null) {
        this.setMiniCartHTML(response);
        window.dispatchEvent(new CustomEvent('openMiniCart'));
        window.dispatchEvent(new CustomEvent('updateCounterInSearch'));
      }
    });
  },
  changeQuantityMiniCart: function (event: any) {
    const parentDiv = event.currentTarget?.closest('.saig-o-mini-cart__item');
    const changedQuantity = event.currentTarget?.value;
    this.getDataAttributes(event);
    postUpdateMiniCart(this.lineItemId, event.currentTarget?.value, this.updateCartInfoURL ?? '')
      .then((response) => {
        if (response != null) {
          this.triggerGAEventOnQuantityChange(parentDiv, changedQuantity);
          this.getCartInfo();
        }
      })
      .catch((error) => {
        console.log('error calling API: ' + error);
      });
  },
  setMiniCartHTML: function (response?: any) {
    this.listItemMiniCart = document?.querySelector<HTMLElement>('.saig-o-header-menu__icons__item__cart');
    this.listItemMiniCart && (this.listItemMiniCart.innerHTML = response);
    this.addEvent();
    this.getParsedAPIUrls();
    window.dispatchEvent(new CustomEvent('addMiniCartClickEvent'));
    window.dispatchEvent(new CustomEvent('cartChanged'));
  },
  licenseRuleClickHandler: function (event: any) {
    event?.preventDefault();
    event?.stopPropagation();
    this.showModal(true, this.popUpIdDocumentLicenseRules);
  },
  getDataAttributes: function (event: any) {
    const parentDiv = event.currentTarget?.closest('.saig-o-mini-cart__item');
    const dataAttr = parentDiv?.dataset.attrItem;
    const parsedDataAttr = dataAttr && JSON.parse(dataAttr?.replace(/&quot;/g, '"'));
    this.popUpIdMoreInfo = parsedDataAttr.PopUpIdMoreInfo;
    this.lineItemId = parsedDataAttr.ItemId;
  },
  moreInfoClickHandler: function (event: any) {
    this.getDataAttributes(event);
    this.showModal(true, this.popUpIdMoreInfo);
  },
  showModal: function (show: boolean, popUpId?: string, confirmCallback?: any, closeCallback?: any) {
    window.dispatchEvent<'selectModal'>(
      new CustomEvent('selectModal', { detail: { popUpId: popUpId, confirmCallback, closeCallback, selfControl: true } })
    );
  },
};

miniCart.init();

export { miniCart };
